/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
  ActivityTableItem,
  PublicBookmark,
} from 'js/user_cards/components/activity_table_item.wjs.jsx';
import { UserCard } from 'js/academia_components/cards/user_card';
import _ from 'underscore';
import { trackAnalyticsClick } from 'js/analytics/metrics/analyticsTracking';

const MainTable = ({ title, children }) => {
  if (_.isEmpty(children)) return null;

  return (
    <div className="wp-usercard-main responsive_margins">
      <div className="wp-usercard-main__title">{title}</div>
      <table className="wp-usercard-main__table">
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

export const ReaderCard = ({
  read_events,
  reader,
  recent_activity,
  anon = false,
}) => {
  const onProfileClick = () =>
    trackAnalyticsClick(
      'analytics-content-link',
      { link_type: 'profile', table: 'readers' },
      Number.isInteger(reader.id) ? reader.id : undefined,
    );

  return (
    <UserCard anon={anon} user={reader} onProfileClick={onProfileClick}>
      <div>
        <MainTable title="Recent Activity">
          {read_events.map(({ id, ...props }, index) => (
            <ActivityTableItem
              {...props}
              key={index}
              onTitleClick={() =>
                trackAnalyticsClick(
                  'analytics-content-link',
                  {
                    link_type:
                      props.type === 'profile_view' ? 'profile' : 'paper',
                    table: 'readers',
                  },
                  Number.isInteger(props.work?.id) ? props.work.id : undefined,
                )
              }
            />
          ))}
        </MainTable>
        <MainTable title="Recently Bookmarked">
          {recent_activity.map(({ work_title, url, work_authors }, index) => (
            <PublicBookmark
              key={index}
              type="bookmark"
              title={work_title}
              url={url}
              authors={work_authors}
              onTitleClick={() =>
                trackAnalyticsClick('analytics-content-link', {
                  link_type: 'paper',
                  table: 'readers',
                })
              }
            />
          ))}
        </MainTable>
      </div>
    </UserCard>
  );
};
